/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import ValidatorNumberField from "../../../Validator/ValidatorNumberField";
import { processCostSupportStyle } from "../../processCostSupportStyle";
import { UseForm } from "../../../../types/UseForm";
import { PropertyLoan as PropertyLoanType } from "../../../../types/ProcessCostSupport";

type PropertyLoanProps = {
  path: string;
  propertyLoan: PropertyLoanType;
  handleChange: UseForm["handleChange"];
};
const PropertyLoan = ({ path, propertyLoan, handleChange }: PropertyLoanProps) => {
  return (
    <>
      <Grid sx={processCostSupportStyle.question} size={12}>
        Machen Sie hier bitte nähere Angaben zu dem Kredit.
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4
        }}>
        <TextField
          fullWidth={true}
          name={path + ".date"}
          label="Datum des Darlehensvertrages"
          margin="normal"
          value={propertyLoan.date}
          onChange={handleChange}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4
        }}>
        <TextField
          fullWidth={true}
          name={path + ".borrowers"}
          label="Darlehensnehmer"
          margin="normal"
          value={propertyLoan.borrowers}
          onChange={handleChange}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4
        }}>
        <TextField
          fullWidth={true}
          name={path + ".bank"}
          label="Kreditinstitut"
          margin="normal"
          value={propertyLoan.bank}
          onChange={handleChange}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4
        }}>
        <TextField
          fullWidth={true}
          name={path + ".remainingTerm"}
          label="Zahlungen laufen bis"
          margin="normal"
          value={propertyLoan.remainingTerm}
          helperText={"Bis wann müssen Sie noch abbezahlen? Zum Beispiel: Mai 2022"}
          onChange={handleChange}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4
        }}>
        <ValidatorNumberField
          fieldType={"money"}
          numberType={"float"}
          fullWidth={true}
          name={path + ".outstandingDebt"}
          label="Aktuelle Restschuld"
          margin="normal"
          value={propertyLoan.outstandingDebt}
          onChange={handleChange}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4
        }}>
        <ValidatorNumberField
          fieldType={"money"}
          numberType={"float"}
          fullWidth={true}
          name={path + ".repayment"}
          label="Zinsen und Tilgung pro Monat"
          margin="normal"
          value={propertyLoan.repayment}
          onChange={handleChange}
        />
      </Grid>
    </>
  );
};

export default PropertyLoan;
